//import types from '../actions/types';

// import types from "../actions/types";
// import produce from "immer/dist/immer";
//
// const initialState = {
//   selected: 'text',
//   object: null
// };

const initialState = {
  languages: {
    ja: '日本語対応フォント',
    en: '英語対応フォント'
  },
  fonts: [
    //{label: '筑紫明朝 Pr6', value: 'TsukuMinPr6-LB', bold: 'TsukuMinPr5-E', fontplus: true, lang: 'ja'},
    //{label: '秀英角ゴシック金', value: 'FOT_DNPShueiGoKinStd-L', bold: 'FOT_DNPShueiGoKinStd-B', fontplus: true, lang: 'ja'},
    //{label: '秀英丸ゴシック金', value: 'FOT_DNPShueiGoKinStd-L', bold: 'FOT_DNPShueiGoKinStd-B', fontplus: true, lang: 'ja'},
    //{label: '侍', value: 'SamuraiStd-R', bold: 'SamuraiStd-R', fontplus: true, lang: 'ja'},
    //{label: 'ラグランパンチ', value: 'RaglanPunchStd-UB', bold: 'RaglanPunchStd-UB', fontplus: true, lang: 'ja'},
    //{label: 'マティスえれがんと', value: 'MatisseElegantoPro-DB', bold: 'MatisseElegantoPro-EB', fontplus: true, lang: 'ja'},
    //{label: 'コミックミステリ', value: 'ComicMysteryStd-DB', bold: 'ComicMysteryStd-DB', fontplus: true, lang: 'ja'},
    //{label: 'ドットゴシック 12', value: 'DotGothic12Std-M', bold: 'DotGothic12Std-M', fontplus: true, lang: 'ja'},
    {label: '源ノ角ゴシック', value: 'sourcehansansr', bold: 'sourcehansansb', fontplus: false, lang: 'ja'},
    {label: 'しっぽりゴシック(ひらがなのみ)', value: 'shipporig', bold: 'shipporig', fontplus: false, lang: 'ja'},
    {label: 'しっぽり明朝', value: 'shipporim', bold: 'shipporim', fontplus: false, lang: 'ja'},
    {label: '全児童フォント', value: 'zenjidojpfeltpen', bold: 'zenjidojpfeltpen', fontplus: false, lang: 'ja'},
    {label: 'しねきゃぷしょん', value: 'cinecaption', bold: 'cinecaption', fontplus: false, lang: 'ja'},
    //{label: 'GD高速道路ゴシックJA', value: 'GDhwGoJA', bold: 'GDhwGoJA', fontplus: false, lang: 'ja'},
    {label: 'ニコモジタイププラス', value: 'nicomoji', bold: 'nicomoji', fontplus: false, lang: 'ja'},
    {label: '廻想体', value: 'kaiso', bold: 'kaiso', fontplus: false, lang: 'ja'},
    {label: '黒薔薇シンデレラ', value: 'kurobara', bold: 'kurobara', fontplus: false, lang: 'ja'},
    //{label: 'Calligri', value: 'FOTCalligri', bold: 'FOTCalligriB', fontplus: true, lang: 'en'},
    //{label: 'Comic Shop', value: 'FOTComicShop', bold: 'FOTComicShopB', fontplus: true, lang: 'en'},
    //{label: 'Space Odyssey', value: 'FOTSpaceOdyssey', bold: 'FOTSpaceOdysseyB', fontplus: true, lang: 'en'},
    {label: 'Copperplate Gothic', value: 'copperplate-1', bold: 'copperplate-2', fontplus: false, lang: 'en'},
    {label: 'Engraver’s old English', value: 'oldeng-1', bold: 'oldeng-2', fontplus: false, lang: 'en'},
    {label: 'Summer Hearts', value: 'summerhearts', bold: 'summerhearts', fontplus: false, lang: 'en'},
    {label: 'Buckwheat TC', value: 'buckwheat-regular', bold: 'buckwheat-regular', fontplus: false, lang: 'en'},
    {label: 'Buckwheat TC Rough', value: 'buckwheat-rough', bold: 'buckwheat-rough', fontplus: false, lang: 'en'},
    {label: 'Judo', value: 'judo', bold: 'judo', fontplus: false, lang: 'en'},
    {label: 'Summer of 76', value: 'summerof76', bold: 'summerof76', fontplus: false, lang: 'en'},
    {label: '123456', value: 'uzubiscuit', bold: 'uzubiscuit', fontplus: false, lang: 'en'},
    {label: 'CODE 3X', value: 'code3x-r', bold: 'code3x-b', fontplus: false, lang: 'en'}
  ]
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/fontsReducer.js